<template>
  <label
    class="ui-switcher"
    :class="{
      'ui-switcher--checked': checked,
      'ui-switcher--disabled': disabled,
      'ui-switcher--rounded': rounded}">
    <input
      v-model="checked"
      class="ui-switcher__input"
      type="checkbox">
    <span class="ui-switcher__inner">
      <span
        class="ui-switcher__check shape-check" />
    </span>
  </label>
</template>

<script>
export default {
  name: 'UiSwitcher',

  props: {
    value: {
      type: [Boolean, String],
      default: false,
    },

    checkedValue: {
      type: String,
      default: null,
    },

    notCheckedValue: {
      type: String,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    rounded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    checked: {
      get() {
        if (this.value) {
          return this.checkedValue ?? this.value;
        }

        return this.notCheckedValue ?? this.value;
      },
      set(value) {
        if (value) {
          this.$emit('input', this.checkedValue ?? value);
        } else {
          this.$emit('input', this.notCheckedValue ?? value);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-switcher {
  --width: 44px;
  --height: 24px;
  --padding: 3px;
  --border-radius: 5px;
  --border-width: 1px;
  //--border-color: #{$color--basic-dark-gray};
  //--border-color-checked: #{$color--basic-blue};
  --bg-color: transparent;
  --bg-color-checked: transparent;
  //--thumb-width: 44.4%;
  --thumb-border-radius: 5px;
  //--thumb-color: #{$color--basic-dark-gray};
  //--thumb-color-checked: #{$color--basic-blue};
  --thumb-transition-transform-time: 0.4s;
  --thumb-transition-transform-easing: cubic-bezier(0.25, 1, 0.5, 1);
  //--thumb-check-display: none;
  //--thumb-check-color: #{$color--basic-blue};

  display: inline-block;
  text-align: left;
  width: var(--width);
  height: var(--height);
  padding: var(--padding);
  cursor: pointer;
  background-color: var(--bg-color);
  border: var(--border-width) solid var(--border-color, #{$color--basic-dark-gray});
  border-radius: var(--border-radius);
  transition-property: background-color, border-color;
  transition-duration: var(--transition-color-time);
  transition-timing-function: var(--transition-color-easing);
}

.ui-switcher__inner {
  display: inline-block;
  height: 100%;
  width: var(--thumb-width, 44.44%);
  border-radius: var(--thumb-border-radius);
  background-color: var(--thumb-color, #{$color--basic-dark-gray});
  transition:
    background-color var(--transition-color-time) var(--transition-color-easing),
    transform var(--thumb-transition-transform-time) var(--thumb-transition-transform-easing);
}

.ui-switcher__input {
  display: none;
}

.ui-switcher__check {
  --shape-color: var(--thumb-check-color, #{$color--basic-blue});

  display: none;
  position: absolute;
}

.ui-switcher--checked {
  border-color: var(--border-color-checked, #{$color--basic-blue});
  background-color: var(--bg-color-checked);

  .ui-switcher__check {
    display: var(--thumb-check-display, none);
    width: 42%;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}

.ui-switcher--checked > .ui-switcher__inner {
  background-color: var(--thumb-color-checked, #{$color--basic-blue});
  transform: translateX(calc(var(--width) - var(--padding) * 2 - var(--border-width) * 2)) translateX(-100%);
}

.ui-switcher--disabled {
  opacity: 0.5;
  pointer-events: none;
}

.ui-switcher--rounded {
  --width: 48px;
  --height: 32px;
  --padding: 4px;
  --border-radius: 100px;
  --border-width: 0px;
  --bg-color: #{$color--basic-dark-gray};
  --bg-color-checked: #{$color--basic-blue};
  --thumb-border-radius: 50%;
  --thumb-width: 24px;
  --thumb-color: #{$color--basic-light-gray};
  --thumb-color-checked: #{$color--basic-white};
  --thumb-check-display: block;
}
</style>
